module.exports = __webpack_public_path__ + "static/media/angle-arrow-up-primary-hover.763b9dea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/angle-arrow-up-primary-hover.svg
// module id = 545
// module chunks = 0